import script from "./TranslationTreeItem.vue?vue&type=script&setup=true&lang=js"
export * from "./TranslationTreeItem.vue?vue&type=script&setup=true&lang=js"

import "./TranslationTreeItem.vue?vue&type=style&index=0&id=5ef50740&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ef50740"]])

export default __exports__